<template>
    <b-row>
      <b-col sm="12" xl="10">

        <template v-if="isAdmin">
          <h4>{{ bidder.name }} Bidder Profile</h4>
          <b-card bg-variant="light" title="Admin Settings" class="my-2">
            <b-row>
              <b-col md="2">
                <b-form-group
                  label="Markup Margin">
                  <b-select
                    v-model="bidder.margin"
                    :options="markupOptions">
                  </b-select>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Human Ad Review">
                  <toggle-button
                    v-model="bidder.human_review"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  :disabled="!isSuperAdmin"
                  label="Floor Guidance">
                  <b-select
                    v-model.number="bidder.optimize_floor_percent">
                    <b-select-option :value="0">Off</b-select-option>
                    <b-select-option :value="0.01">1%</b-select-option>
                    <b-select-option :value="0.05">5%</b-select-option>
                    <b-select-option :value="0.10">10%</b-select-option>
                    <b-select-option :value="0.20">20%</b-select-option>
                    <b-select-option :value="0.30">30%</b-select-option>
                    <b-select-option :value="0.40">40%</b-select-option>
                    <b-select-option :value="0.50">50%</b-select-option>
                    <b-select-option :value="0.60">60%</b-select-option>
                    <b-select-option :value="0.70">70%</b-select-option>
                    <b-select-option :value="0.80">80%</b-select-option>
                  </b-select>
                </b-form-group>
              </b-col>
              <!-- <b-col md="3">
                <b-form-group
                  label="Spend-Based Throttle">
                  <toggle-button
                    v-model="bidder.spend_throttle"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col> -->
              <b-col md="2">
                <b-form-group
                  label="WinURL Support">
                  <toggle-button
                    v-model="bidder.nurl"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Multi Imp Support">
                  <toggle-button
                    v-model="bidder.multi_imp"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  :disabled="!isSuperAdmin"
                  label="Custom IVT Threshold">
                  <b-select
                    v-model.number="bidder.ivt_threshold">
                    <b-select-option :value="0">System Default (50%)</b-select-option>
                    <b-select-option :value="0.05">5%</b-select-option>
                    <b-select-option :value="0.10">10%</b-select-option>
                    <b-select-option :value="0.20">20%</b-select-option>
                    <b-select-option :value="0.30">30%</b-select-option>
                    <b-select-option :value="0.40">40%</b-select-option>
                  </b-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <b-card class="my-2">
          <h5 class="my-4">General Settings</h5>
          <b-form-row>
            <b-col md="8">
              <b-form-group
                label="Bidder Display Name">
                <b-form-input
                  type="text"
                  v-model="bidder.name">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Nightly Stats Emails">
                <toggle-button
                  v-model="bidder.stats_emails"
                  :sync="true"
                  color="#2bd879">
                </toggle-button>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-row class="mt-4">
            <b-col>
              <b-form-group
              label="User Syncing" class="pb-0 mb-0"></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-alert class="w-100" :show="!bidder.syncs || !bidder.syncs.length">
                No user syncing configured
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card v-for="(sync, index) in bidder.syncs" :key="index" v-if="bidder.syncs && bidder.syncs.length"
                no-body class="mb-1 w-100">
                <b-card-header @click="$root.$emit('bv::toggle::collapse', 'sync-' + index)" header-tag="header" class="border-bottom-0 cursor-pointer p-2 w-100" role="tab">
                  <i class="icon-Button_Dropdown mr-5 font-weight-bold align-middle" />
                  {{ sync.sync_url.length ? sync.sync_url : 'New Cookie Sync' }}
                  <b-btn variant="link" class="p-0 mr-3 m-0 float-right text-danger" @click="deleteSync(sync)">
                    x
                  </b-btn>
                </b-card-header>
                <b-collapse :id="'sync-' + index" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-alert show variant="info">
                      We will initiate a call to your sync url if provided. You may use our
                      <code>${REDIRECT}</code> macro in your link and we will dynamically add
                      our encoded callback. If using the redirect macro, please put your user id
                      macro in the uid macro input box below and we will add this to our redirect parameter.
                      If no uid macro present, append it to the end of the redirect.
                    </b-alert>
                    <b-alert variant="warning" :show="sync.sync_url && sync.sync_url.indexOf('${REDIRECT}') === -1">
                      No redirect found in your URL. Please sync back to us at:<br />
                      <code>https://sync.smrtb.com/sync/all?pid={{ cid }}&rid=YOUR UID HERE</code>
                    </b-alert>
                    <b-form-row>
                      <b-col md="12">
                        <b-form-group
                          label="Cookie Sync Pixel URL">
                          <b-form-input
                            type="text"
                            v-model="sync.sync_url">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col md="4">
                        <b-form-group
                          label="Sync User Id Macro">
                          <b-form-input
                            type="text"
                            v-model="sync.sync_uid_macro">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                          label="Sync Is Iframe">
                          <toggle-button
                            v-model="sync.sync_is_iframe"
                            :sync="true"
                            color="#2bd879">
                          </toggle-button>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="btn-sm mt-2" variant="primary" @click="addEmptySync()">
                <i class="icon-Add mr-3"></i>
                Add Sync
              </b-button>
            </b-col>
          </b-row>

          <b-form-row class="mt-5">
            <b-form-group label="Ads.txt Reseller Entries" class="w-100">
              <b-form-textarea v-model="bidder.adstxt_indirect" max-rows="15"
                               placeholder="Paste your ads.txt RESELLER entries here that should be provided to publishers you do not have a direct billing relationship with"></b-form-textarea>
            </b-form-group>
          </b-form-row>
          <b-form-row>
            <b-form-group label="Ads.txt Direct Entries" class="w-100">
              <b-form-textarea v-model="bidder.adstxt_direct" max-rows="15"
                             placeholder="Paste your ads.txt DIRECT entries here that should be provided to publishers you have a direct relationship with"></b-form-textarea>
            </b-form-group>
          </b-form-row>
          <b-btn @click="save()" variant="primary" class="mt-4">{{ status === 'loaded' ? 'Save Changes' : 'Create'}}</b-btn>
        </b-card>

        <b-card no-body class="my-2" v-if="bidder.company_id === '112' && bidder.epsilon_mapping">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="muted" class="rounded-0">Epsilon Bundle Mappings</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--
              <b-form-row v-for="[bundle, appid] of Object.entries(bidder.epsilon_mapping)" :key="appid" class="mb-5">
                <b-col>
                  <b-input-group prepend="Bundle">
                    <b-form-input placeholder="app.com.bundle" disabled :value="bundle"/>
                  </b-input-group>
                </b-col>
                <b-col>
                  <b-input-group prepend="App.Id">
                    <b-form-input placeholder="epsilon id 123456" disabled :value="appid" />
                  </b-input-group>
                </b-col>
                <b-col>
                  <b-button @click="delEpsilonMapping(bundle)" variant="danger">Delete</b-button>
                </b-col>
              </b-form-row>
              -->

              <div class="mt-3">
                <h6 class="text-muted">Add New Mapping</h6>
                <b-form-row>
                  <b-col>
                    <b-input-group prepend="Bundle">
                      <b-form-input v-model="epsilonTmp.bundle" placeholder="app.com.bundle" />
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <b-input-group prepend="App.Id">
                      <b-form-input v-model="epsilonTmp.appid" placeholder="epsilon id 123456" />
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <b-button @click="epsilonAddMapping" variant="primary" circle>+ Add</b-button>
                  </b-col>
                </b-form-row>
              </div>

              <b-table striped hover :fields="[ 'bundle', 'appid', 'btns' ]"
                       :items="epsilonTableItems"
                       show-empty borderless class="mb-5">
                <template #cell(btns)="data">
                  <b-button size="sm" @click="delEpsilonMapping(data.item.bundle)" variant="danger">X</b-button>
                </template>
                <template #empty="scope">
                  No Bundle Mappings Created Yet
                </template>
              </b-table>
            </b-card-body>
          </b-collapse>
        </b-card>


        <b-card class="my-2">
          <h5 class="my-4">
            Endpoints
          </h5>
          <b-alert :show="status === 'new'" variant="info">
            After you save your bidder profile you may configure endpoints
          </b-alert>
          <b-alert :show="status === 'loaded' && !endpoints.length" variant="danger">
            You must configure at least 1 endpoint to receive bid requests
          </b-alert>
          <b-alert :show="endpoints && endpoints.length > 1" variant="light" class="bg-light">
            Please note bid requests will be sent to <b>one</b> matching endpoints
          </b-alert>
          <b-list-group v-if="status !== 'new'">
            <b-list-group-item v-for="endpoint in endpoints" :key="endpoint.id"
                               class="d-flex justify-content-between align-items-center">
              <div class="w-25 text-nowrap">
                <toggle-button
                  class="my-auto mr-4"
                  v-model="endpoint.enabled"
                  :sync="true"
                  @change="updateEndpoint(endpoint)"
                  color="#2bd879">
                </toggle-button>
                {{ endpoint.name }}
              </div>
              <b-input-group class="w-25">
                <b-input-group-text slot="prepend">
                  QPS
                </b-input-group-text>
                <b-form-input
                  v-model="endpoint.qps"
                  @change="updateEndpoint(endpoint)"
                  required>
                </b-form-input>
              </b-input-group>
              {{ endpoint.datacenter }}
              <b-btn variant="outline-secondary" :to="{ name: 'BidderEndpointSettings', params: { cid: companyId(), eid: endpoint.id } }">
                Edit <i class="icon icon-Settings" />
              </b-btn>
              <b-btn v-if="isAdmin" variant="light" :to="{ name: 'ThrottleStats', params: { cid: companyId(), epid: endpoint.id } }">
                Insights <i class="icon icon-Reports" />
              </b-btn>
            </b-list-group-item>
          </b-list-group>
          <b-btn :disabled="status === 'new'"
                 :to="{ name: 'BidderEndpointNew', params: { cid: companyId() } }"
                 variant="primary" class="mt-4">
            + Add Endpoint
          </b-btn>
        </b-card>

      </b-col>
    </b-row>
</template>

<script>
    import {DemandApi} from '@/demand/api'
    import {CompanyApi} from "../../company/api"
    import Mulselect from '@/components/Mulselect'
    import auth from '@/auth'
    import StringListEditor from '@/components/StringListEditor'
    import ManySelector from '@/components/ManySelector'

    export default {
        props: {
            cid: {required: false}
        },
        data() {
            return {
                status: 'loading',
                bidder: {
                    ivt_threshold: 0,
                    margin: 100,
                    company_id: this.companyId(),
                    name: null,
                    stats_emails: true,
                    human_review: true,
                    nurl: true,
                    syncs: []
                },
                company: {},
                endpoints: [],
                isAdmin: auth.isAdmin(),
                isSuperAdmin: auth.isSuperAdmin(),
                adUnitOptions: {
                    1: 'Banner',
                    2: 'Video',
                    3: 'Native',
                },
                markupOptions: [
                    {value: 200, text: '200%'},
                    {value: 190, text: '190%'},
                    {value: 180, text: '180%'},
                    {value: 170, text: '170%'},
                    {value: 160, text: '160%'},
                    {value: 150, text: '150%'},
                    {value: 140, text: '140%'},
                    {value: 130, text: '130%'},
                    {value: 120, text: '120%'},
                    {value: 110, text: '110%'},
                    {value: 100, text: '100%'},
                    {value: 90, text: '90%'},
                    {value: 80, text: '80%'},
                    {value: 70, text: '70%'},
                    {value: 60, text: '60%'},
                    {value: 50, text: '50%'},
                    {value: 30, text: '30%'},
                    {value: 20, text: '20%'},
                    {value: 0, text: '0%'},
                ],
                epsilonTmp: {
                  bundle: null,
                  appid: null
                },
                optimize_floor_percent: 0
            }
        },
        created() {
            DemandApi.details(this.companyId()).then((bidder) => {
                if (bidder) {
                    this.bidder = bidder;
                    if (bidder['optimize_floor_percent'] == undefined)
                      bidder['optimize_floor_percent'] = 0;
                    DemandApi.endpoints(this.companyId()).then((list) => {
                        this.endpoints = list
                        this.status = 'loaded'
                    })
                } else {
                    this.status = 'new'
                }
            }).catch(() => this.status = 'new')
            if(this.cid) {
                CompanyApi.details(this.cid).then((details) => {
                    this.company = details
                    this.bidder.name = details.name
                })
            } else {
                this.company = auth.company()
                this.bidder.name = this.company.name
            }
        },
        methods: {
            save() {
                DemandApi.set(this.bidder).then((data) => {
                    this.$notify.success('Profile saved')
                    if(this.status === 'new') {
                        this.$router.go() /* refresh */
                    }
                }, (err) => {
                    this.$notify.error(err)
                })
            },
            csvToArray(csv) {
                if (csv.length === 0)
                    return []
                else
                    return csv.split(',')
            },
            arrayToCsv(array) {
                return array.join(',')
            },
            updateEndpoint(ep) {
                DemandApi.endpoint(ep).then((r) => {
                    this.$notify.success('Endpoint settings updated')
                })
            },
            companyId () {
                if (this.cid) {
                    return this.cid
                }
                return auth.details().company_id
            },
            addEmptySync () {
                let syncs = this.bidder.syncs
                if (!syncs) {
                    syncs = []
                    this.$set(this.bidder, 'syncs', syncs)
                }

                for(let sync of syncs) {
                    if(!sync.sync_url.length || sync._saved === false) {
                        this.$notify.warning("Please save current sync first")
                        return; // already have new entry waiting
                    }
                }

                syncs.push({ _saved: false, sync_url: '', sync_is_iframe: false, sync_uid_macro: '' })
                this.$nextTick(() => this.$root.$emit('bv::toggle::collapse', ('sync-' + (syncs.length - 1))))

            },
            deleteSync (sync) {
                this.bidders.sync.splice(this.bidders.sync.indexOf(sync), 1)
                this.save()
            },
            epsilonAddMapping () {
              if (!this.epsilonTmp.bundle || !this.epsilonTmp.appid)
                return this.$notify.warning("Mapping must have bundle and app.id value")

              this.$set(this.bidder.epsilon_mapping, this.epsilonTmp.bundle, this.epsilonTmp.appid)

              this.epsilonTmp = {
                bundle: null,
                appid: null
              }
            },
            delEpsilonMapping (bundle) {
              this.$delete(this.bidder.epsilon_mapping, bundle)
            }
        },
        computed: {
            epsilonTableItems () {
              if (!this.bidder.epsilon_mapping)
                return []

              const items = []
              for ([bundle, appid] of Object.entries(this.bidder.epsilon_mapping))
                items.push({ bundle, appid })

              return items;
            }
        },
        components: {
            Mulselect,
            StringListEditor,
            ManySelector
        }
    }
</script>



// WEBPACK FOOTER //
// src/demand/pages/Settings.vue